module.exports = __webpack_public_path__ + "img/icon-mh-bs.2258c5bd.png";